var _style, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteriorDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#111111;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 4,
    y: 52,
    width: 56,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,36v12h44V36H10z M50,44H14v-4h36V44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,30v18h8V30H4z M8,44H8H8z M8,44H8v0H8z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 4,
    y: 30,
    width: 8,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 52,
    y: 30,
    width: 8,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 10,
    y: 24,
    width: 44,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 12,
    y: 48,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 48,
    y: 48,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,6l6,6L36,28h-6v-6L46,6z M33,25.2V28h2.8L33,25.2z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 64,
    height: 64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorDesign);
export default __webpack_public_path__ + "static/media/InteriorDesign.105c7a4137385ce55a6e5f73560a387f.svg";
export { ForwardRef as ReactComponent };